<template>
  <div class="access_point_page">
    <DetachHardwarePopup v-if="detachHardwareData" :popupActive="detachHardwarePopups"
      @popup="detachHardwarePopups = $event" :propsData="detachHardwareData" :deviceId="detachDevId" />

    <vs-prompt title="Confirm Delete" class="export-options" @cancel="cancelConfirmDelete" @accept="acceptDelete"
      accept-text="YES" @close="cancelConfirmDelete" :active="confirmACUDelete" cancel-text="No">
      <div class="flex">
        <h5>The device is not responding. Do you still want to delete it? </h5>
      </div>
    </vs-prompt>
    <vs-prompt title="Export To Excel" class="export-options" @cancel="clearFields" @accept="exportToExcel"
      accept-text="Export" @close="clearFields" :active.sync="activePrompt">
      <vs-input v-model="fileName" @input="fileName = $event" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <vs-popup class="holamundo" title="Choose ACU Table headers" :active.sync="popups.acu_columns_popup">
      <vs-checkbox v-for="(header, index) in acu_headers" :key="index" class="mb-4 mt-5 custom__checkbox"
        v-model="header.show" :disabled="header.field === 'actions'">{{ header.headerName }}</vs-checkbox>
      <div class="screen_false">
        <vs-button class="mt-4 unimacs_button" @click="changeAcuHeaders" :disabled="isDisabledItems">Submit
        </vs-button>
        <vs-button class="mr-6 mt-4 unimacs_cancel_button" @click="popups.acu_columns_popup = false">Cancel</vs-button>
      </div>
    </vs-popup>

    <vs-popup class="holamundo" title="Choose Access Points headers" :active.sync="popups.point_columns_popup">
      <vs-checkbox v-for="(header, index) in access_point_headers" :key="index" class="mb-4 mt-5 custom__checkbox"
        v-model="header.show" :disabled="header.field === 'actions'">{{ header.headerName }}</vs-checkbox>

      <div class="screen_false">
        <vs-button class="mt-4 unimacs_button" @click="changeApHeaders" :disabled="isDisabledItems">Submit
        </vs-button>

        <vs-button class="mr-6 mt-4 unimacs_cancel_button" @click="popups.point_columns_popup = false">Cancel
        </vs-button>
      </div>
    </vs-popup>

    <AttachHardwarePopup v-if="attachHardData" :popupActive="popups.attachHardwarePopup"
      @popup="popups.attachHardwarePopup = $event" :propsData="attachHardData" :deviceId="deviceId" />

    <AddACU :popupActive="popups.addACUPopup" @popup="popups.addACUPopup = $event" :page="page"
      :page_items_count="itemsPerPage" :page_point="pagePoint" :page_items_count_point="itemsPerPagePoint" />

    <vs-popup class="holamundo popup_width_small ac_point__popup updatee" title="Update ACU / Access Point"
      :active.sync="popups.editACUPopup">
      <UpdateACU :page="page" :page_items_count="itemsPerPage" :page_point="pagePoint"
        :expansion_boards="expansion_boards" :controllers_boards="controllers_boards"
        :page_items_count_point="itemsPerPagePoint" v-if="popups.editACUPopup" class="popup_width_small" />
    </vs-popup>

    <vs-popup class="react-wizard holamundo " title="Create ACU" :active.sync="acuPopUp">
      <div v-if="acuPopUp && acuModels">
        <CreateACUReactWrapper :acuModels="acuModels" :closeACUModal="handleCloseACUModal"
          :showNotification="showNotification" />
      </div>
    </vs-popup>


    <vx-card class="mt-base" title="Access Control Unit" v-if="acuTable">
      <div class="vx-row" :key="accessControlUnitKey">
        <div class="vx-col w-full">
          <div class="add_access_point">
            <vs-button class="unimacs_button mr-5" @click="
              exportType = 'acu';
            activePrompt = true;
            " :disabled="access_points && !access_points.length">Export</vs-button>
            <v-select v-model="itemsPerPage" :options="[15, 50, 100, 500, 1000]" class="select_padding ev_log_lim mr-3"
              name="ap_type" placeholder="Limit" :dir="$vs.rtl ? 'rtl' : 'ltr'" :clearable="false"
              :searchable="false" />
            <vs-button color="#14c3ed" @mouseover="normal_hovered = true" @mouseleave="normal_hovered = false"
              @click="synchronization()" class="mr-4" :disabled="isDisabledItems">Synchronization</vs-button>

            <vs-button class="mr-4 unimacs_button unimacs_add_new_btn" @click="handleAddUser"
              v-if="acuPermissions.addItem" :disabled="isDisabledItems">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4 mr-1" /> Add ACU
            </vs-button>

            <vs-button @click="popups.acu_columns_popup = true" class="unimacs_button" icon-pack="material-icons"
              icon="filter_list"></vs-button>
          </div>
          <AcuTable :items="acuData" :headers="filter_acu_headers" @updateItem="editACU($event)"
            :key="accessControlUnitKey" @changeAcuHeadersOrdered="changeAcuHeadersOrdered($event)" />
          <CustomPaging class="log_page" @pageChanged="page = $event" :total="totalPage"
            v-show="itemsPerPage < acu_count && acuData.length ? true : false" />
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import VueSocketIOExt from "vue-socket.io-extended";
import io from "socket.io-client";
import AcuTable from "../access-point/components/tables/AcuTable";

import CreateACUReactWrapper from "../access-point/components/acu/CreateACUReactWrapper.vue"

import Table from "../../components/custom/table/Table";
import moduleAccessPoint from "../../store/access-point/moduleAccessPoint";
import moduleGroupZone from "../../store/group-zones/moduleAccessPoint";
import AddDevicePopup from "../access-point/components/popups/AddDeviceDragDrop";
import AddACU from "../access-point/components/popups/acu/AddACU";
import UpdateACU from "../access-point/components/popups/acu/UpdateACUPopup";
import AttachHardwarePopup from "../access-point/components/popups/AttachHardwarePopup";
import DetachHardwarePopup from "../access-point/components/tabs/acu/update/AttachFromACU.vue";
import CellRendererApActions from "../access-point/renderer/CellRendererApActions";

import vSelect from "vue-select";

import store from "../../store/access-point/moduleAccessPoint.js";
export default {
  watch: {
    activePrompt(val) {
      if (!val) {
        this.fileName = "";
      }
    },
    "$store.state.isDisabledAllFields"(val) {
      return this.toggleIsDisabledItems(val);
    },
    "store.state.acu"(val) {
      return this.updateACUData(val);

    },

    "store.state.confirmACUDelete"(val) {
      this.$vs.loading.close();
      this.toggleConfirmACUDelete(val);
      return
    },
    "popups.point_columns_popup"(value) {
      this.access_point_headers = JSON.parse(JSON.stringify(this.ap_header));
      return
    },
    "popups.acu_columns_popup"(value) {
      return this.acu_headers = JSON.parse(JSON.stringify(this.acu_header));
      // this.access_point_headers = JSON.parse(JSON.stringify(this.ap_header));
    },
    "popups.editACUPopup"(value) {
      const user = localStorage.user ? JSON.parse(localStorage.user) : null;
      if (!value && user && this.$socket) {
        this.$socket.$unsubscribe(
          `reader_delete/${user.company}/${user.id}/acu/${this.acu_id}`
        );
        this.$socket.$unsubscribe(
          `ext_brd_delete/${user.company}/${user.id}/acu/${this.acu_id}`
        );
        this.$socket.$unsubscribe(
          `ext_brd_update/${user.company}/${user.id}/acu/${this.acu_id}`
        );
      }
      return
    },
    itemsPerPage() {
      const params = {
        page: 1,
        page_items_count: this.itemsPerPage,
      };

      this.fetchAcus(params);
      return
    },
    page() {
      const params = {
        page: this.page,
        page_items_count: this.itemsPerPage,
      };

      this.fetchAcus(params);
      return
    },
    itemsPerPagePoint() {
      const params = {
        page: 1,
        page_items_count: this.itemsPerPagePoint,
      };

      this.fetchPoints(params);
      return
    },
    pagePoint() {
      const params = {
        page: this.pagePoint,
        page_items_count: this.itemsPerPagePoint,
      };

      this.fetchPoints(params);
      return
    },
  },
  methods: {
    connectSocket() {
      if (this.socket && this.socket.on) {
        this.setupSocketListeners();
        return;
      }
      this.socket = io(`${process.env.VUE_APP_SOCKET_PORT}/`, {
        withCredentials: false,
        query: { token: localStorage.token },
      });

      Vue.use(VueSocketIOExt, this.socket);

      this.$nextTick(() => {
        this.socketConnected = false;
        setTimeout(() => {
          this.connectSocket();
        }, 3000);
      });
    },

    setupSocketListeners() {
      if (!this.socket || typeof this.socket.on !== "function") {
        return;
      }

      this.socket.on("connect", () => {
        this.socketConnected = true;
      });

      this.socket.on("disconnect", () => {
        this.socketConnected = false;
        setTimeout(() => {
          this.connectSocket();
        }, 3000);
      });

      const user = localStorage.user ? JSON.parse(localStorage.user) : null;
      if (user && user.company) {
        this.socket.emit("subscribe", `acu_update_cloud_status/${user.company}`);

        this.socket.on(`acu_update_cloud_status/${user.company}`, (payload) => {
          this.handleSocketUpdate(payload);
        });
      }
    },

    closeSocket() {
      if (this.socket) {
        this.socket.disconnect(); // Disconnect the socket
        this.socket.removeAllListeners(); // Remove all event listeners
      }
    },

    handleSocketUpdate(payload) {
      let res = JSON.parse(payload);
      res.serial_number = `${res.serial_number}`;
      this.acuData = this.acuData.map((item) =>
        `${item.serial_number}` === `${res.serial_number}`
          ? { ...item, ...res, disabled: res.cloud_status === "offline" }
          : item
      );
      const params = {
        page: 1,
        page_items_count: this.itemsPerPage,
      };
      this.$store.commit("accessPoint/SET_ACUS", { acus: this.acuData, params, counts: this.acu_count });
      this.$root.$emit("refreshAcuTable");
    },

    acuCounts() {
      return this.$store.state.accessPoint.acu_count
    },

    handleCloseACUModal() {
      const params = {
        page: this.page,
        page_items_count: this.itemsPerPage,
      };
      this.fetchAcus(params);
      this.acuPopUp = false
    },
    handleAddUser() {
      if (!this.acuPopUp) {
        this.$store.dispatch("accessPoint/fetchAcuModels").then((res) => {
          this.acuModels = res.data.controllers
          this.$vs.loading.close();
        });
      }
      this.acuPopUp = !this.acuPopUp
    },
    showNotification(data) {
      this.$vs.notify(data || {
        time: 7000,
        color: "success",
        title: "ACU Deleted",
      });
      // this.$vs.notify();
    },

    toggleIsDisabledItems(val) {
      this.isDisabledItems = val
    },
    updateACUData(val) {
      this.acuData = val;
    },

    checkAccessPointResource() {
      this.popups.acuPopUp = true;
    },

    toggleConfirmACUDelete(value) {
      this.confirmACUDelete = value
    },

    async changeApHeadersPosition(data) {
      let newHeader = this.changeOrder([...this.access_point_headers], data);
      const settings = JSON.parse(JSON.stringify(this.settingsStore));
      if (settings.table_headers) {
        settings.table_headers.access_point_headers = newHeader;
      } else {
        settings.table_headers = {
          access_point_headers: newHeader,
        };
      }

      this.access_point_headers = newHeader;
      await this.$store.dispatch("setSettings", settings)
    },

    changeOrder(array, headerOrder) {
      const headerIndexMap = headerOrder.reduce((map, header, index) => {
        map[header] = index;
        return map;
      }, {});
      return array
        .filter(item => headerIndexMap.hasOwnProperty(item.headerName))
        .sort((a, b) => headerIndexMap[a.headerName] - headerIndexMap[b.headerName]);
    },

    async changeApHeaders() {
      const settings = JSON.parse(JSON.stringify(this.settingsStore));
      settings.table_headers.access_point_headers = this.access_point_headers;
      this.ap_header = JSON.parse(JSON.stringify(this.access_point_headers));
      await this.$store.dispatch("setSettings", settings);
      this.popups.point_columns_popup = false;
      this.accessControlUnitKey = this.accessControlUnitKey + 1
      this.$root.$emit("refreshAcApTable");
    },

    async changeAcuHeadersOrdered(data) {
      let newHeader = this.changeOrder([...this.acu_headers], data);
      const settings = JSON.parse(JSON.stringify(this.settingsStore));
      if (settings.table_headers) {
        settings.table_headers.acu_headers = newHeader;
      } else {
        settings.table_headers = {
          acu_headers: newHeader,
        };
      }
      this.acu_headers = newHeader;
      await this.$store.dispatch("setSettings", settings)
    },

    async changeAcuHeaders() {
      const settings = JSON.parse(JSON.stringify(this.settingsStore));
      settings.table_headers.acu_headers = this.acu_headers;
      this.acu_header = JSON.parse(JSON.stringify(this.acu_headers));
      await this.$store.dispatch("setSettings", settings);
      // this.setSettings(settings);
      this.popups.acu_columns_popup = false;
      this.$root.$emit("refreshAcuTable");
    },
    activateACU(event) {
      this.$vs.loading({
        type: "corners",
      });
      this.$store.dispatch("accessPoint/activateACU", event.id).then((res) => {
        this.$vs.notify({
          time: 7000,
          color: "success",
          title: "Hardware activated",
        });
        this.$vs.loading.close();
      });
      this.$vs.loading.close();
    },
    editACU(event) {
      if (this.isDisabledItems) {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: "Please wait synchronization to end",
        });
        return false

      }
      if (event && event.status === "pending") {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: "ACU is not activate",
        });
        return false
      }
      this.$store.dispatch("accessPoint/fetchACU", event.id).then((res) => {
        setTimeout(() => {
          this.acu_id = event.id;
          this.popups.editACUPopup = true;
        }, 200);
      });

    },
    copyACU(event) {
      if (event.status === "active") {
        this.copy_acu = event.id;
        let findAction = this.contextMenuActions.find(
          (a) => a.action === "paste"
        );
        findAction.disabled = false;

        this.$vs.notify({
          time: 7000,
          color: "success",
          title: "ACU Copied",
        });
      } else {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: "Can't copy inactive ACU",
        });
      }
    },
    pastACU(event) {
      if (event.cloud_status === "online") {
        if (event.status === "active") {
          if (this.copy_acu === event.id) {
            this.$vs.notify({
              time: 7000,
              color: "danger",
              title: "Can't paste on the same copied ACU",
            });
          } else if (this.copy_acu) {
            this.$store
              .dispatch("accessPoint/pasteACU", {
                acu_copy: this.copy_acu,
                acu_paste: event.id,
              })
              .then(async () => {
                this.$vs.notify({
                  time: 7000,
                  color: "success",
                  title: "Successfully installed",
                });
                const params = {
                  page: this.page,
                  page_items_count: this.itemsPerPage,
                };

                await this.fetchAcus(params);
              });
          } else {
            this.$vs.notify({
              time: 7000,
              color: "danger",
              title: "At first select ACU for copy",
            });
          }
        } else {
          this.$vs.notify({
            time: 7000,
            color: "danger",
            title: "Can't paste on inactive ACU",
          });
        }
      } else {
        if (this.copy_acu) {
          this.$vs.notify({
            time: 7000,
            color: "danger",
            title:
              "The operation could not be completed because the device is not online",
          });
        } else {
          this.$vs.notify({
            time: 7000,
            color: "danger",
            title: "At first select ACU for copy",
          });
        }
      }
    },
    attachACU(event) {
      if (event.status == "no_hardware") {
        this.popups.attachHardwarePopup = true;
        this.$store.dispatch("accessPoint/fetchAttachHardware").then((res) => {
          this.attachHardData = { attach_hard: res.data, device: event };
          this.deviceId = event.id;
        });
      } else {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: "Selected ACU hasn't No Hardware Status",
        });
      }
    },
    deleteAp(event) {
      this.deleteApItem = event;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete`,
        text: `Do You want to delete ${this.deleteApItem.name} Access Point `,
        accept: this.deleteApFunction,
        acceptText: "Delete",
      });
    },
    deactivateConfirm(event) {
      this.deactivateItem = event;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete`,
        text: `Do You want to delete ${this.deactivateItem.name} ACU `,
        accept: this.deactivateAcu,
        acceptText: "Delete",
      });
    },
    deactivateAcu() {
      if (this.isDisabledItems) { return false }
      this.$store
        .dispatch("accessPoint/deactivateAcu", this.deactivateItem)
        .then((response) => {
          this.$vs.notify({
            time: 7000,
            color: "success",
            title: "ACU deactivated",
          });
        });
    },
    synchronization(event) {

      this.$store.dispatch("fetchSynchCUPItem", event ? event.id : "").then(() => {
      }).catch((message) => {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: message,
        });
      })
    },

    deleteApFunction() {
      if (this.isDisabledItems) { return false }
      this.$vs.loading({
        type: "corners",
      });
      this.$store
        .dispatch("accessPoint/deleteAccessPoint", { ...this.deleteApItem, page: this.pagePoint })
        .then((res) => {
          this.$vs.loading.close();
          this.$vs.notify({
            time: 7000,
            color: "success",
            title: "Access Point Deleted",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            time: 7000,
            color: "danger",
            title: "Something went wrong!!!",
          });
          this.$vs.loading.close();
        });
    },
    deleteACU(event) {
      this.deleteACUItem = event;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete`,
        text: `Do You want to delete ${this.deleteACUItem.name} ACU `,
        accept: this.deleteNode,
        acceptText: "Delete",
      });
    },
    async getData() {
      const pointParams = {
        page: this.pagePoint,
        page_items_count: this.itemsPerPagePoint,
      };
      const params = {
        page: this.page,
        page_items_count: this.itemsPerPage,
      };
      await this.fetchAcus(params);

      await this.fetchPoints(pointParams);

      this.$vs.loading.close();
      this.$vs.notify({
        time: 7000,
        color: "success",
        title: "ACU Deleted",
      });
    },
    deleteNode() {
      if (this.isDisabledItems) { return false }

      this.$vs.loading({
        type: "corners",
      });
      this.$store
        .dispatch("accessPoint/deleteACU", this.deleteACUItem)
        .then(async (res) => {
          if (res) {
            await this.getData()
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    updateAccessPoint(event) {
      if (!event.disabled) {
        this.$store.dispatch("accessPoint/fetchACU", event.acu).then((res) => {
          setTimeout(() => {
            this.popups.editACUPopup = true;
          }, 200);
        });
      }
    },
    acceptDelete() {

      this.$vs.loading({
        type: "corners",
      });
      this.$store
        .dispatch("accessPoint/deleteACU", { ...this.deleteACUItem, forced: true })
        .then(async (res) => {

          await this.getData()
          this.cancelConfirmDelete()
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.cancelConfirmDelete()
        })
    },
    exportToExcel() {
      const name = this.fileName;

      import("@/vendor/Export2Excel").then((excel) => {
        const list = this.acuData
        const header =
          this.exportType == "acu"
            ? this.acu_headers.map((item) => {
              if (item.field !== "actions") {
                return item.headerName;
              }
            })
            : this.access_point_headers.map((item) => {
              if (item.field !== "actions") {
                return item.headerName;
              }
            });

        const headerVal = this.acu_headers.map((item) => {
          return item.field;
        })

        const data = this.formatJson(headerVal, list);
        excel.export_json_to_excel({
          header: header,
          data,
          filename: name,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.clearFields();
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    cancelConfirmDelete() {
      this.$store.dispatch("accessPoint/closeConfirmModal");
    },
    clearFields() {
      this.filename = null;
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },
    detachHardware(event) {
      this.detachHardwarePopups = true;
      const id = event.id;

      this.$store.dispatch("accessPoint/fetchAttachHardware").then((res) => {
        this.detachDevId = id;
        this.detachHardwareData = { attach_hard: res.data, device: event };
      });
    },
    submitScreen() {
      const point_table = localStorage.getItem("point_table");
      const acu_table = localStorage.getItem("acu_table");
      this.apTable = point_table == "false" ? false : true;
      this.acuTable = acu_table == "false" ? false : true;
    },




    async fetchAcus(params) {
      this.$store.dispatch("accessPoint/fetchACUs", params).then((res) => {
        this.$vs.loading.close();
        const sum = this.acu_count % this.itemsPerPage;
        if (!sum) {
          this.totalPage = Math.floor(this.acu_count / this.itemsPerPage);
        } else {
          this.totalPage = Math.floor(this.acu_count / this.itemsPerPage) + 1;
        }
        setTimeout(() => {
          this.$root.$emit("refreshAcuTable");
        }, 300);
      });
    },
    fetchPoints(params) {

      this.$store.dispatch("accessPoint/fetchAccessPoint", params).then(() => {
        this.$vs.loading.close();

        const sum = this.point_count % this.itemsPerPagePoint;
        if (!sum) {
          this.totalPagePoint = Math.floor(
            this.point_count / this.itemsPerPagePoint
          );
        } else {
          this.totalPagePoint =
            Math.floor(this.point_count / this.itemsPerPagePoint) + 1;
        }

        setTimeout(() => {
          this.$root.$emit("refreshAcApTable");
        }, 300);
      });
    },

    addMissingFields(mainArray, updatedArray) {
      const newFelids = updatedArray.map(item => {
        if (item.field === "sync_status") {
          return { ...item, cellRendererFramework: "CellRendererSynchStatus" }
        }
        if (item.field === "actions") {
          return {
            ...item, pinned: "right",
            lockPinned: true,
            show: true,
            lockPosition: "right",
          }
        }
        return item
      })
      const updatedFields = new Set(newFelids.map(item => item.field));

      const missingFields = mainArray.filter(item => !updatedFields.has(item.field));
      return [...newFelids, ...missingFields];
    },

    mergeArrays(array1, array2) {
      const array1Fields = new Map(array1.map(item => [item.field, item]));
      array2.forEach(item => {
        if (!array1Fields.has(item.field)) {
          array1.push(item);
        }
      });

      return [...array1];
    },
  },
  async created() {
    if (!moduleAccessPoint.isRegistered) {
      this.$store.registerModule("accessPoint", moduleAccessPoint);
      moduleAccessPoint.isRegistered = true;
    }

    if (!moduleGroupZone.isRegistered) {
      this.$store.registerModule("accessPointGroup", moduleGroupZone);
      moduleGroupZone.isRegistered = true;
    }
    this.submitScreen();



    const settings = JSON.parse(JSON.stringify(this.settingsStore));
    if (!settings) {
      await this.$store.dispatch("setSettings", {
        table_headers: {
          access_point_headers: this.access_point_headers,
          acu_headers: this.acu_headers,
        },
      });
      this.ap_header = JSON.parse(JSON.stringify(this.access_point_headers));
      this.acu_header = JSON.parse(JSON.stringify(this.acu_headers));
    } else {
      if (settings.table_headers) {
        if (settings.table_headers.access_point_headers && this.access_point_headers) {
          settings.table_headers.access_point_headers = this.mergeArrays(settings.table_headers.access_point_headers, this.access_point_headers);
        }

        const saveSettings = { ...settings };

        if (settings.table_headers.access_point_headers) {
          this.ap_header = JSON.parse(
            JSON.stringify(settings.table_headers.access_point_headers)
          );
          this.access_point_headers = JSON.parse(
            JSON.stringify(this.ap_header)
          );
        } else {
          saveSettings.table_headers.access_point_headers =
            this.access_point_headers;
          this.ap_header = JSON.parse(
            JSON.stringify(this.access_point_headers)
          );
        }
        if (settings.table_headers.acu_headers) {
          this.acu_header = this.acu_headers
          this.acu_header = this.addMissingFields(this.acu_headers, JSON.parse(
            JSON.stringify(settings.table_headers.acu_headers)
          ));


          this.acu_headers = JSON.parse(JSON.stringify(this.acu_header));

        } else {
          saveSettings.table_headers.acu_headers = this.acu_headers;
          this.acu_header = JSON.parse(JSON.stringify(this.acu_headers));
        }
        await this.$store.dispatch("setSettings", saveSettings);
      } else {
        const saveSettings = { ...settings };
        saveSettings.table_headers = {
          access_point_headers: this.access_point_headers,
          acu_headers: this.acu_headers,
        };
        this.acu_header = JSON.parse(JSON.stringify(this.acu_headers));
        this.ap_header = JSON.parse(JSON.stringify(this.access_point_headers));
        await this.$store.dispatch("setSettings", saveSettings);
      }
    }

    this.$vs.loading({
      type: "corners",
    });
    const pointParams = {
      page: this.pagePoint,
      page_items_count: this.itemsPerPagePoint,
    };
    this.fetchPoints(pointParams);

    const params = {
      page: this.page,
      page_items_count: this.itemsPerPage,
    };

    await this.fetchAcus(params);


    this.$store.dispatch("accessPoint/fetchAccessPointTypes").then((res) => {
      this.$vs.loading.close();
    });

    if (this.acuPermissions && this.acuPermissions.destroyItem) {
      this.contextMenuActions.push({ name: "Delete", action: "delete" });
    }

    if (this.acuPermissions && this.acuPermissions.updateItem) {
      this.contextMenuActions.push({ name: "Edit", action: "updateItem" });
    }
  },
  mounted() {
    this.isDisabledItems = this.$store.state.isDisabledAllFields;
    this.acuData = store.state.acu;
    this.$root.$on("deleteAccessP", (data) => {
      this.deleteAp(data);
    });

    this.$root.$on("updateAccessP", (data) => {
      this.updateAccessPoint(data);
    });

    this.$root.$on("activateAcu", (data) => {
      this.activateACU(data);
    });

    this.$root.$on("copyAcu", (data) => {
      this.copyACU(data);
    });

    this.$root.$on("pasteAcu", (data) => {
      this.pastACU(data);
    });

    this.$root.$on("attachHardwareAcu", (data) => {
      this.attachACU(data);
    });

    this.$root.$on("detachHardwareAcu", (data) => {
      this.detachHardware(data);
    });

    this.$root.$on("updateItemAcu", (data) => {
      this.editACU(data);
    });

    this.$root.$on("deleteAcu", (data) => {
      this.deleteACU(data);
    });
    this.$root.$on("closeUpdatePopup", () => {
      this.popups.editACUPopup = false;
    });
    this.$root.$on("synchronization", (data) => {
      this.synchronization(data)
    });
    this.$store.dispatch("accessPoint/fetchAcuModels").then((res) => {
      this.acuModels = res.data.controllers
      this.expansion_boards = res.data.expansion_boards;
      this.controllers_boards = res.data.controllers;
      this.$vs.loading.close();
    });

    this.connectSocket();

  },
  data() {
    return {
      controllers_boards: null,
      expansion_boards: null,
      socket: null,
      socketConnected: false,
      accessControlUnitKey: 0,
      acuModels: null,
      acuPopUp: false,
      acuData: [],
      confirmACUDelete: false,
      fileName: "",
      ap_name: null,
      port: null,
      address: null,
      boud_rate: null,
      acu_id: null,
      store,
      updateACU_propsData: null,
      attachHardData: null,
      popups: {
        addAccessPointPopup: false,
        addDevicePopup: false,
        attachHardwarePopup: false,
        addACUPopup: false,
        acu_columns_popup: false,
        point_columns_popup: false,
        editACUPopup: false,
        editApPopup: false,
      },
      acuDeleteConfirm: false,
      ap_header: [],
      access_point_headers: [
        {
          headerName: "#",
          field: "count",
          filter: true,
          pinned: "left",
          lockPinned: true,
          lockPosition: "left",
          cellClass: "locked-col",
          maxWidth: 100,
          minWidth: 100,
          width: 100,
          suppressSizeToFit: true,
          show: true,
        },
        {
          headerName: "Name",
          field: "name",
          filter: true,

          minWidth: 130,
          show: true,
        },
        {
          headerName: "ACU Name",
          field: "acu_name",
          filter: true,
          show: true,
        },
        {
          headerName: "Type",
          field: "type",
          filter: true,
          show: true,

        },
        {
          headerName: "Group",
          field: "group",
          filter: true,
          show: true,
        },
        {
          headerName: "Status",
          field: "acu_status",
          filter: true,
          show: true,

          cellRendererFramework: "CellRendererAcuStatus",
        },
        {
          headerName: "Mode",
          field: "mode",
          filter: true,
          show: true,
        },
        {
          headerName: "Actions",
          field: "actions",

          cellRendererFramework: "CellRendererApActions",
          filter: false,
          show: true,
          maxWidth: 120,
          minWidth: 120,
          width: 120,
        },
      ],
      components: {
        CellRendererApActions,
      },
      acu_header: [],
      acu_headers: [
        {
          headerName: "#",
          field: "count",
          filter: true,

          pinned: "left",
          lockPinned: true,
          lockPosition: "left",
          cellClass: "locked-col",
          maxWidth: 100,
          width: 100,
          suppressSizeToFit: true,
          show: true,
        },
        {
          headerName: "Name",
          field: "name",
          filter: true,

          minWidth: 160,
          width: 160,
          show: true,
        },
        {
          headerName: "Model",
          field: "model",
          filter: true,

          minWidth: 140,
          width: 140,
          show: true,
        },
        {
          headerName: "ACU Serial Number",
          field: "serial_number",
          filter: true,

          minWidth: 220,
          width: 220,
          show: true,
        },
        {
          headerName: "Slots",
          field: "slots",
          filter: true,
          show: true,
          cellRendererFramework: "CellRendererAcuSlot",
          minWidth: 150,
          width: 150,
        },
        {
          headerName: "Device Status",
          field: "status",
          filter: true,
          show: true,

          cellRendererFramework: "CellRendererStatus",
          minWidth: 180,
          width: 180,
        },
        {
          cellRendererFramework: "CellRendererSynchStatus",
          headerName: "Synch Status",
          field: "sync_status",
          show: true,
          minWidth: 180,
          width: 180,
        },
        {
          headerName: "Cloud Connection",
          field: "cloud_status",
          filter: true,
          show: true,

          cellRendererFramework: "CellRendererCloudStatus",
          minWidth: 200,
          width: 200,
        },
        {
          headerName: "Connection Type",
          field: "connection_type",
          filter: true,
          show: true,

          minWidth: 190,
          width: 190,
        },
        {
          headerName: "IP Address",
          field: "ip_address",
          filter: true,
          show: true,

          minWidth: 150,
          width: 150,
        },
        {
          headerName: "Reg. Date",
          field: "registration_date",
          filter: true,
          show: false,

          minWidth: 180,
          width: 180,
        },
        {
          headerName: "Last Online",
          field: "last_online",
          filter: true,
          show: true,

          minWidth: 180,
          width: 180,
        },
        {
          headerName: "FW Ver",
          field: "fw_version",
          filter: true,
          show: true,

          minWidth: 140,
          width: 140,
        },
        {
          headerName: "HW Ver",
          field: "rev",
          filter: true,

          show: false,
          minWidth: 140,
          width: 140,
        },
        {
          headerName: "API ver",
          field: "api_ver",
          filter: true,

          show: false,
          minWidth: 140,
          width: 140,
        },
        {
          headerName: "ACU Comment",
          field: "acu_comment",
          filter: true,

          show: false,
          minWidth: 180,
          width: 180,
        },
        {
          headerName: "Actions",
          field: "actions",
          show: true,

          cellRendererFramework: "CellRendererAcuActions",
          pinned: "right",
          lockPinned: true,
          lockPosition: "right",
          cellClass: "locked-col",
          maxWidth: 120,
          minWidth: 120,
          width: 120,
          suppressSizeToFit: true,
        },
      ],
      contextMenuActions: [
        // { name: "Activate", action: "activate" },
        { name: "Copy", action: "copy" },
        { name: "Paste", action: "paste", disabled: true },
        { name: "Attach Hardware", action: "attachHardware" },
        { name: "Change Acu", action: "detachHardware" },
      ],
      contextMenuAPActions: [
        { name: "Delete", action: "delete" },
        { name: "Edit", action: "updateItem" },
      ],
      deleteACUItem: null,
      apTable: true,
      deleteApItem: null,
      acuTable: true,
      deviceId: null,
      upd_acu_component: null,
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: [],
      headerVal: [],
      activePrompt: false,
      exportType: "acc_point",
      detachHardwarePopups: false,
      detachHardwareData: null,
      detachDevId: null,
      copy_acu: null,
      paste_acu: null,
      itemsPerPage: 15,
      page: 1,
      totalPage: 0,
      pagePoint: 1,
      totalPagePoint: 0,
      itemsPerPagePoint: 15,
      isDisabledItems: false
    };
  },
  computed: {
    // acu() {
    //   return store.state.acu;
    // },
    deleteConfirmModal() {
      this.$vs.loading.close();
      return store.state.confirmACUDelete;
    },
    acu_count() {
      return store.state.acu_count;
    },
    acuPermissions() {
      return localStorage.permissions
        ? JSON.parse(localStorage.permissions).Acu
          ? JSON.parse(localStorage.permissions).Acu.actions
          : null
        : null;
    },
    access_pointPermissions() {
      return localStorage.permissions
        ? JSON.parse(localStorage.permissions).AccessPoint
          ? JSON.parse(localStorage.permissions).AccessPoint.actions
          : null
        : null;
    },
    access_points() {
      return store.state.access_points;
    },
    point_count() {
      return store.state.access_points_count;
    },
    // filter_acu_headers() {
    //   return this.acu_headers.filter((h) => h.show);
    // },
    filter_acu_headers() {
      return this.acu_header.filter((h) => {
        return 'show' in h ? h.show : true;
      });
    },
    filter_access_point_headers() {
      return this.ap_header.filter((h) => {
        return 'show' in h ? h.show : true;
      });
    },
    settingsStore() {
      return this.$store.state.settings;
    },
    totalPages() {
      return this.gridApi && this.gridApi.paginationGetTotalPages
        ? this.gridApi.paginationGetTotalPages()
        : 0;
    },
  },
  components: {
    Table,
    AddDevicePopup,
    AttachHardwarePopup,
    AddACU,
    UpdateACU,
    DetachHardwarePopup,
    vSelect,
    AcuTable,
    CellRendererApActions,
    CreateACUReactWrapper
  },
  beforeDestroy() {
    this.$root.$off("refreshAcApTable");
    this.$root.$off("refreshAcuTable");
    this.$root.$off("deleteAccessP");
    this.$root.$off("updateAccessP");
    this.$root.$off("activateAcu");
    this.$root.$off("copyAcu");
    this.$root.$off("pasteAcu");
    this.$root.$off("attachHardwareAcu");
    this.$root.$off("detachHardwareAcu");
    this.$root.$off("updateItemAcu");
    this.$root.$off("deleteAcu");
    this.$root.$off("closeUpdatePopup");
    this.$root.$off("synchronization");
    // this.disconnectSocket();
    // this.closeSocket();
    this.socket.disconnect(); // Disconnect the socket
    this.socket.removeAllListeners(); // Remove all event listeners
  },
};
</script>

<style lang="scss">
@import url("../access-point/css/style.css");

.react-wizard {
  .vs-popup {
    width: 90%;
    max-width: 1350px;

  }

}

.react-wizard {

  .vs-popup ::-webkit-scrollbar {
    width: 8px;
  }

  .vs-popup ::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 4px;
  }

  .vs-popup ::-webkit-scrollbar-thumb {
    background: #7367f0;
    border-radius: 4px;
  }

}

.access_point_page {
  .vx-card__header {
    position: absolute;
  }

  .table_block {
    .table_title {
      margin-top: 40px;
    }

    table {
      td {
        padding-top: 10px;
      }

      margin-top: 10px;
      width: 100%;
    }
  }

  .select_block {
    display: flex;
    margin: -15px;

    .v-select {
      flex: 0 0 33.33%;
      padding: 15px;
    }
  }

  .actions_block_acuu {
    .add_device {
      margin-left: 15px;
    }
  }

  .add_access_point {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }

  .popup_width_small {
    .vs-popup--content {
      padding-bottom: 0 !important;
    }

    .vs-popup {
      min-width: 1000px;
      min-height: 680px;
      max-height: 750px;
    }
  }
}
</style>

<style lang="scss">
.access_point_page {
  position: relative;

  .scr_config_acu {
    position: absolute;
    top: -46px;
    right: 0;

    .button {
      z-index: 9999999;
    }
  }

  .ap_tbl__padding {
    .con-input-search.vs-table--search {
      margin-right: 175px;
      margin-top: -60px;
    }

    .tr-values {
      .vs-table--td {
        padding: 0 15px !important;
      }
    }
  }

  .ap_tbl_padding {
    .con-input-search.vs-table--search {
      margin-right: 320px;
      margin-top: -60px;
    }

    .tr-values {
      .vs-table--td {
        padding: 0 15px !important;
      }
    }
  }

  .scr_config_acu {
    display: flex;
    flex-direction: row-reverse;
  }

  .screen_false {
    display: flex;
    flex-direction: row-reverse;
  }
}

.ac_point__popup .vs-popup {
  min-width: 950px !important;
}

// .ap_ag_grid {
//   height: auto;
// }</style>